import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useListConnectActions = (connectId: number) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'actions', connectId],
    queryFn: () => connectService.listActions(connectId),
    enabled: !!connectId
  });

  return { actions: data?.data ?? [], isLoading, error, refetch };
};
